<template>
  <div v-if="show" class="app-popup__overlay" @click.self="onBackdrop">
    <div
      class="app-popup__card"
      :class="[cardClass, scrollable ? 'app-popup__card--scroll' : '', fullscreenMobile ? 'app-popup__card--fs-mobile' : '']"
    >
      <!-- When a `title` is provided, the heading and close button share one
           flex row so they're always vertically aligned. Without it, the close
           button keeps its standalone top-right position (backward compatible). -->
      <div v-if="title" class="app-popup__header">
        <h3 class="app-popup__title">{{ title }}</h3>
        <button
          v-if="showClose"
          type="button"
          class="app-popup__close app-popup__close--inline"
          :data-testid="closeTestId || undefined"
          aria-label="Chiudi"
          @click="$emit('close')"
        >
          <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#A4A4A4"
               stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 6 L18 18 M18 6 L6 18" />
          </svg>
        </button>
      </div>
      <button
        v-else-if="showClose"
        type="button"
        class="app-popup__close"
        :data-testid="closeTestId || undefined"
        aria-label="Chiudi"
        @click="$emit('close')"
      >
        <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#A4A4A4"
             stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 6 L18 18 M18 6 L6 18" />
        </svg>
      </button>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "BasePopup",
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: "" },
    cardClass: { type: String, default: "" },
    fullscreenMobile: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: false },
    closeOnBackdrop: { type: Boolean, default: true },
    showClose: { type: Boolean, default: true },
    closeTestId: { type: String, default: "" },
  },
  emits: ["close"],
  methods: {
    onBackdrop() {
      if (this.closeOnBackdrop) this.$emit("close");
    },
  },
};
</script>
